<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;



    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(', ');

            width = +title[1].split('x')[0];
            height = +title[1].split('x')[1];


            ind2 = title[6].split(' ')[1].replace('Ral', ''); // "  7016  "

            for (var element of color_type) {
                if (title[6].includes(element)) {
                    ind10 = element;
                }
            }


            for (var element of kolvostkol) {
                if (title[3].includes(element + ' шт.')) {
                    ind12 = element;
                }
            }

            for (var element of ost_type) {
                if (title[2].includes(element)) {
                    ind3 = element;
                }
            }

            if (ind3==='Холодная'){

                for (var key in glassCould) {
                    if (title[3].includes(key)) {
                        ind4 = key;
                    }
                }
            }
            else{
                for (var key in glassWarm) {
                    if (title[3].includes(key)) {
                        ind4 = key;
                    }
                }
            }


            for (var element of avtomat) {
                if (title[5].includes(element)) {
                    ind6 = element;
                }
            }


            for (var element of otkr_type) {
                if (title[4].includes(element)) {
                    ind5 = element;
                }
            }


            if (item.title.includes('алюм. труба')) {
                ind11 = title[7].replace('алюм. труба ', '');
            } else {
                ind11 = '';
            }


            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch();
            change();
        }
    };


    const ost_type = [
        'Холодная',
        'Теплая',
    ];


    const otkr_type = [
        'вниз',
        'вверх',
    ];

    const avtomat = [
        'Mosel 140(Турция)',
        'Becker 120(Германия)',
    ];

    const kolvostkol = [
        '2',
        '3',
    ];

    const color_type = [
        'Глянцевый',
        'Матовый',
        'Муар',
    ];
    const glassCould = {
        '8 зак прозрачное': '8 зак прозрачное',
        '8 зак Бронза': '8 зак Бронза',
        '8 зак Грей': '8 зак Грей',
        '6зак/8 /6 зак': '6зак/8 /6 зак',
        '6 МФ зак /8/6 зак': '6 МФ зак /8/6 зак',
    };

    const glassWarm = {
        '6зак/12/6зак': '6зак/12/6зак',
        '6 МФ зак /12/6 зак': '6 МФ зак /12/6 зак',
    };


    const fetch = async (color = '') => {
        let result = await network.fetch_data('Гильотина', '', '');
        let options = await network.fetch_ind('Гильотина');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let

        height = '',
        width = '',
        ind2 = '', // цвет RAL
        ind3 = 'Холодная', // тип
        ind4 = '8 зак прозрачное', // стекло
        ind5 = 'вниз', // Вид открывания
        ind6 = 'Mosel 140(Турция)', // Автоматика
        ind10 = 'Глянцевый', // тип цвета
        ind11 = '', // длинна  Труба алюминиевая
        ind12 = '2', // длинна  Труба алюминиевая
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),

        stvwid = ''
    ;

    let fetchData = fetch();


    let title;

    const changeInd4 = () => {
        if (ind4.startsWith(6) ) {
            width = Math.min(width, 3500)
        }
    };


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count;

        if (ind5 =='вверх' && ind3 =='Холодная'){
            toastbox('toast', 3000);

        }


        if (ind11 > 0) {
            title = [
                'Система Гильотина, ', width + 'x' + height, ', тип ',
                ind3, ', стекло ', ind4, ' ', ind12, ' шт., направление ', ind5 ,', автоматика ', ind6, ', цвет Ral', ind2, ' ', ind10, ', алюм. труба ', ind11
            ].join('')

        } else {
            title = [
                'Система Гильотина, ', width + 'x' + height, ', тип ',
                ind3, ', стекло ', ind4, ' ', ind12, ' шт., направление ', ind5 ,', автоматика ', ind6, ', цвет Ral', ind2, ' ', ind10
            ].join('')


        }


        let result = {
            type: 'Система Гильотина',
            name: 'Система Гильотина',
            subname: title.replace('Система Гильотина, ', ''),
            title: title,
            params: {
                ind1: ind5.toLowerCase() + '-' + ind12,
                ind2: 'Ral' + ind2 + ' ' + ind10,
                ind3: 'тип ' + ind3 + ', стекло ' + ind4 + ' ' + ind12 + ' шт., направление '+ ind5 + ', автоматика ' + ind6,
                ind4: width,
                ind5: height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 67
        };

            stvwid = '';


        _.forEach(data.result, function (el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();
            let h  = item.ind4.toLowerCase();
            let w = item.ind5.toLowerCase();
            let artikul = item.artikul.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;



            if (name.includes(ind4.toLowerCase())) {
                kolvo = ((+width ) * (+height ) / 1000000).toFixed(3);
            }


            if (name.includes(ind6.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('труба алюминий 100х100 длинна 3м') && +ind11 > 0 && +ind11 <= 3000) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('труба алюминий 100х100 длинна 6м') && +ind11 > 3000) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('м.кв')) {
                if ( artikul.toLowerCase() == ind3.toLowerCase() &&  1*(h.split('-')[0]) <= height  &&  1*(h.split('-')[1]) >=height  &&  1*(w.split('-')[0])<= width  &&  1*(w.split('-')[1])>=width  ) {
                kolvo = 1;
                }
            }
            // работа с ценами

            if (name.includes('м.кв') && ind10 == 'Муар') { // +3% к цене за квадрат при выборе Муар
                item.price = item.price / 100 * 103;
                item.opt_price = item.opt_price / 100 * 103;
            }

           /* if (item.ind1 === '1') {  //убираем из расчет материалы, которые входят в стоимость м.кв.
                item.price = item.opt_price = 0;
            }*/


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        /*result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);*/

        result.price.rozn = (_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn') * 1.1).toFixed(2);
        result.price.opt = (_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt') * 1.1).toFixed(2);
        result.price.sebest = (_.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest') * 1.1).toFixed(2);


        dispatch('item', result);
    }, 250);

    change();
</script>

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">

            <div class="col-12 col-sm-5">

                <div class="form-group boxed mb-3">
                    <div class="input-wrapper">
                        <label class="form-label">Количество изделий</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}
                               use:validate_int={count}>
                    </div>
                </div>

                <div class="text-center">
                    <img style="max-height: 250px" class="img-fluid px-3" alt="{ind5.toLowerCase()}-{ind12}"
                         src="/img/slaydors/открывание-{ind5.toLowerCase()}-{ind12}.jpg"/>
                </div>
                {#if width * height > 0 }
                    <div class="row pt-3">
                        <div class="col-12 text-center">
                            <span class="form-label text-center">
                                { stvwid.split(' мм.').join(" мм. ") }
                            </span>
                        </div>
                        <div class="col-12 text-center">
                            <span class="form-label text-center">Площадь остекления: {((+width) * (+height) / 1000000).toFixed(2)} м.кв.</span>
                        </div>
                    </div>
                {/if}
            </div>
            <div class="col-12 col-sm-7">


                <div class="row">

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип</label>
                                <select class="form-control form-select" bind:value={ind3} >
                                    {#each ost_type as value }
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">Вид открывания</label>

                                <select class="form-control form-select" bind:value={ind5}>
                                    {#each otkr_type as value}
                                        <option value="{value}">{value}</option>
                                    {/each}

                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Стекло</label>
                                <select class="form-control form-select" bind:value={ind4} on:change={() => {changeInd4(); change()}}>
                                    {#each (ind3 === 'Холодная' ?  Object.entries(glassCould) :  Object.entries(glassWarm)) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество створок</label>
                                <select class="form-control form-select" bind:value={ind12}>
                                    {#each (kolvostkol) as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>

                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">1900 ≥ Ширина, мм ≥ {(ind4.startsWith(8) ?  4200 :  3500)}</label>
                                <input type="number" class="form-control" step="10" min="1900"
                                       max="{(ind4.startsWith(8) ?  4200 :  3500)}"
                                       bind:value={width}
                                       use:validate_int={width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">250 ≥ Высота, мм ≥ 3500</label>
                                <input type="number" class="form-control" step="10" min="250" max="3500" bind:value={height} use:validate_int={height}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет Ral</label>
                                    <input type="number" class="form-control" use:validate_not_empty={ind2}
                                           bind:value={ind2}>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип окрашивания</label>
                                    <select class="form-control form-select" bind:value={ind10}>
                                        {#each color_type as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                </div>

                <div class="row pt-3">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Автоматика</label>
                                <select class="form-control form-select" bind:value={ind6}>
                                    {#each avtomat as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>

                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Труба алюминиевая 100х100, мм</label>
                                <input type="number" class="form-control" bind:value={ind11}>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Примечание</label>
                                    <textarea class="form-control" bind:value={$comment}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

<div id="toast" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            Временно не доступно к продаже
        </div>
    </div>
</div>
